import { Box } from '@rbilabs/universal-components';

import Picture from 'components/picture';

export const PointLabel = Box.withConfig({
  paddingX: '$2',
  height: '$6',
  width: '$24',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: Styles.color.loyaltyHighlight,
  borderRadius: 'md',
  flexDirection: 'row',
});

export const RewardImage = Picture.withConfig({
  width: '124px',
  height: '100px',
  marginBottom: '$4',
  alignSelf: 'center',
});
